import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  HomeIcon,
  CubeIcon,
  CurrencyDollarIcon,
  BuildingStorefrontIcon,
  ShoppingBagIcon,
  ArrowPathIcon,
} from "@heroicons/react/24/outline";

// Mobile bottom navigation - visible only on small screens
export default function MobileBottomNav({ onOpenSubscriptionModal }) {
  const location = useLocation();
  const segments = (location.pathname || "").replace(/^\/+|\/+$/g, "").split("/");
  let base = "";
  const nonTenantPrefixes = ["api", "login", "register", "forgot-password", "verify-email", "reset-password", "static", "assets", "favicon.ico"];
  const storedTenant = localStorage.getItem("tenant");
  if (storedTenant) base = `/${storedTenant}`;
  else if (segments.length >= 2 && segments[0].toLowerCase() === "t") base = `/t/${segments[1]}`;
  else if (segments.length >= 1 && segments[0] && !nonTenantPrefixes.includes(segments[0].toLowerCase())) base = `/${segments[0]}`;

  return (
    // fixed bottom nav only on small screens
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t lg:hidden z-40">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center py-2">
          <Link to="." className="flex flex-col items-center text-xs text-gray-600">
            <HomeIcon className="h-5 w-5" />
            <span>Dashboard</span>
          </Link>
          <Link to="inventory" className="flex flex-col items-center text-xs text-gray-600">
            <CubeIcon className="h-5 w-5" />
            <span>Inventory</span>
          </Link>
          <Link to={`${base}/sales`} className="flex flex-col items-center text-xs text-gray-600">
            <CurrencyDollarIcon className="h-5 w-5" />
            <span>Sales</span>
          </Link>
          <Link to={`${base}/manage-store`} className="flex flex-col items-center text-xs text-gray-600">
            <BuildingStorefrontIcon className="h-5 w-5" />
            <span>Vendors</span>
          </Link>
          <Link to="returned-products" className="flex flex-col items-center text-xs text-gray-600">
            <ArrowPathIcon className="h-5 w-5" />
            <span>Returns</span>
          </Link>
        </div>
      </div>
    </nav>
  );
}

// simple subscription modal markup appended to file so we don't add new files
export function SubscriptionModal({ open, onClose }) {
    if (!open) return null;
    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-80 p-4 sm:p-0">
            <div className="bg-white rounded-lg shadow-2xl w-full max-w-sm sm:max-w-md p-4 sm:p-6 relative z-[10000]">
                <h3 className="text-base sm:text-lg font-medium text-gray-900">Manage Subscription</h3>
                <p className="mt-3 sm:mt-4 text-sm sm:text-base text-gray-600 leading-relaxed">This feature is coming soon. We are working on subscriptions and billing. Please check back later.</p>
                <div className="mt-6 sm:mt-8 flex justify-end">
                    <button onClick={onClose} className="rounded-md border border-gray-300 px-4 sm:px-5 py-2 text-xs sm:text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors">Close</button>
                </div>
            </div>
        </div>
    );
}
